<template>
    <CollapsibleCardBase>
        <template #title>
            <div class="mt-1 font-bold text-sm">
                {{ $t('component.missionProfile.scope.title') }}
            </div>
        </template>
        <template #content>

            <div class="text-sm leading-tight text-gray-600">
                <div v-if="missionDetail.recruiter_feedback" class="w-full p-1 mb-2">
                    <div class="pr-2">
                        <div>{{ $t('component.missionProfile.scope.recruiter_feedback') }}</div>
                    </div>
                    <div class="mt-2 text-black">
                        {{ missionDetail.recruiter_feedback }}
                    </div>
                </div>

                <div v-if="missionDetail.survey_version === 2">
                    <div class="w-full flex p-1">
                        <div class="w-1/3 text-right pr-2">
                            <div>{{ $t('text.activity.care') }}</div>
                        </div>
                        <div class="w-2/3 text-black">
                            <div class="ml-1 mb-1" v-for="(care, activityCareIndex) in activitiesCares()" :key="activityCareIndex">{{ care }}</div>
                        </div>
                    </div>

                    <div class="w-full flex p-1">
                        <div class="w-1/3 text-right pr-2">
                            <div>{{ $t('text.activity.household') }}</div>
                        </div>
                        <div class="w-2/3 text-black">
                            <div class="ml-1 mb-1" v-for="(household, activityHouseholdIndex) in activitiesHousehold()" :key="activityHouseholdIndex">{{ household }}</div>
                        </div>
                    </div>

                    <div class="w-full flex p-1">
                        <div class="w-1/3 text-right pr-2">
                            <div>{{ $t('text.activity.task') }}</div>
                        </div>
                        <div class="w-2/3 text-black">
                            <div class="ml-1 mb-1" v-for="(task, activityTaskIndex) in activitiesTasks()" :key="activityTaskIndex">{{ task }}</div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="w-full flex p-1">
                        <div class="w-1/3 text-right pr-2">
                            <div>{{ $t('component.missionProfile.scope.activities_main' )}}</div>
                        </div>
                        <div class="w-2/3 text-black">
                            <div class="ml-1 mb-1">{{ missionDetail.activities.main }}</div>
                        </div>
                    </div>

                    <div class="w-full flex p-1" v-if="missionDetail.activities.special_night">
                        <div class="w-1/3 text-right pr-2">
                            <div>{{ $t('component.missionProfile.scope.special_night') }}</div>
                        </div>
                        <div class="w-2/3 text-black">
                            <div class="ml-1 mb-1">{{ missionDetail.activities.special_night }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </CollapsibleCardBase>
</template>

<script>
    import CollapsibleCardBase from "@/components/shared/CollapsibleCardBase";
    export default {
        name: "MissionProfileScope",
        props: ['missionDetail'],
        components: {CollapsibleCardBase},
        methods: {
            activitiesCares() {
                let cares = [];
                let self = this;

                if (this.missionDetail.activities === undefined)
                    return cares;

                this.missionDetail.activities.care.forEach(function (c) {
                    switch (c) {
                        case '0':
                            cares.push(self.$t('text.activityCare_care_0'));
                            break;
                        case '1':
                            cares.push(self.$t('text.activityCare_care_1'));
                            break;
                        case '2':
                            cares.push(self.$t('text.activityCare_care_2'));
                            break;
                        case '3':
                            cares.push(self.$t('text.activityCare_care_3'));
                            break;
                        case '4':
                            cares.push(self.$t('text.activityCare_care_4'));
                            break;
                        case '5':
                            cares.push(self.$t('text.activityCare_care_5'));
                            break;
                        case '6':
                            cares.push(self.$t('text.activityCare_care_6'));
                            break;
                        case '7':
                            cares.push(self.$t('text.activityCare_care_7'));
                            break;
                        case '8':
                            cares.push(self.$t('text.activityCare_care_8'));
                            break;
                        case '9':
                            cares.push(self.$t('text.activityCare_care_9'));
                            break;
                        case '10':
                            cares.push(self.$t('text.activityCare_care_10'));
                            break;
                    }
                });

                if (cares.length === 0)
                    cares.push(self.$t('text.unknown'));

                return cares;
            },

            activitiesHousehold() {
                let households = [];
                let self = this;

                if (this.missionDetail.activities === undefined)
                    return households;

                this.missionDetail.activities.household.forEach(function (c) {
                    switch (c) {
                        case '0':
                            households.push(self.$t('text.activity.household_0'));
                            break;
                        case '1':
                            households.push(self.$t('text.activity.household_1'));
                            break;
                        case '2':
                            households.push(self.$t('text.activity.household_2'));
                            break;
                        case '3':
                            households.push(self.$t('text.activity.household_3'));
                            break;
                        case '4':
                            households.push(self.$t('text.activity.household_4'));
                            break;
                        case '5':
                            households.push(self.$t('text.activity.household_5'));
                            break;
                        case '6':
                            households.push(self.$t('text.activity.household_6'));
                            break;
                        case '7':
                            households.push(self.$t('text.activity.household_7'));
                            break;
                        case '8':
                            households.push(self.$t('text.activity.household_8'));
                            break;
                        case '9':
                            households.push(self.$t('text.activity.household_9'));
                            break;
                        case '10':
                            households.push(self.$t('text.activity.household_10'));
                            break;
                        case '11':
                            households.push(self.$t('text.activity.household_11'));
                            break;
                        case '12':
                            households.push(self.$t('text.activity.household_12'));
                            break;
                        case '13':
                            households.push(self.$t('text.activity.household_13'));
                            break;
                        case '14':
                            households.push(self.$t('text.activity.household_14'));
                            break;
                        case '15':
                            households.push(self.$t('text.activity.household_15'));
                            break;
                        case '99':
                            households.push(self.$t('text.activity.household_99'));
                            break;
                    }
                });

                if (households.length === 0)
                    households.push(self.$t('text.unknown'));

                return households;
            },

            activitiesTasks() {
                let tasks = [];
                let self = this;

                if (this.missionDetail.activities === undefined)
                    return tasks;

                this.missionDetail.activities.grocery_transport_options.forEach(function (c) {
                    switch (c) {
                        case '0':
                            tasks.push(self.$t('text.activity.grocery_transport_options_0'));
                            break;
                        case '1':
                            tasks.push(self.$t('text.activity.grocery_transport_options_1'));
                            break;
                        case '2':
                            tasks.push(self.$t('text.activity.grocery_transport_options_2'));
                            break;
                        case '3':
                            tasks.push(self.$t('text.activity.grocery_transport_options_3'));
                            break;
                    }
                });

                if (tasks.length === 0)
                    tasks.push(self.$t('text.unknown'));

                if (this.missionDetail.help_family_members) {
                    tasks.push(self.$t('component.missionProfile.help.help_family_members'));
                }

                if (this.missionDetail.drivers_license_required) {
                    tasks.push(self.$t('component.missionProfile.help.drivers_license_required'));
                }

                return tasks;
            }
        }
    }
</script>

<style scoped>

</style>